import script from "./PhoneField.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneField.vue?vue&type=script&setup=true&lang=ts"

import "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&lang=css"
import "./PhoneField.vue?vue&type=style&index=1&id=6f10aa1c&lang=scss"

const __exports__ = script;

export default __exports__